import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

function RaiseIssue({ asset_id }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [assetData, setAssetData] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const watchCategory = watch("category");
  const watchServiceType = watch("service_type");

  useEffect(() => {
    if (!asset_id) return;

    const fetchAssetDetail = async () => {
      setGlobalLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/employeeinfos/getAssetDetail/${asset_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setAssetData(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchAssetDetail();
  }, [asset_id]);

  const onSubmit = async (data) => {
    console.log("Form Data Before Submit:", data);

    const formData = new FormData();
    formData.append("subject", data.subject);
    formData.append("description", data.description);
    formData.append("issue_type", "IT");
    formData.append("asset_id", asset_id);
    formData.append("requested_for", assetData?.name || "");
    formData.append("category", data.category || "");
    formData.append("service_type", data.service_type || "");
    formData.append("software_option", data.software_option || "");
    formData.append("hardware", data.hardware || "");

    if (data.image && data.image[0]) {
      formData.append("image", data.image[0]);
    }

    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/employeeinfos/raiseissue`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Form submitted successfully:", response.data);
      alert("Issue submitted successfully!");
      reset();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to raise issue.");
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <>
      <div className="modal fade" id="refuse_msg" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-header">
                <h5 className="modal-title">
                  Raise Issue for Asset #{asset_id}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {/* Subject */}
                <div className="mb-3 row">
                  <label className="form-label col-md-2">Subject</label>
                  <div className="col-md-10">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.subject ? "is-invalid" : ""
                      }`}
                      {...register("subject", {
                        required: "Subject is required",
                      })}
                    />
                    {errors.subject && (
                      <div className="invalid-feedback">
                        {errors.subject.message}
                      </div>
                    )}
                  </div>
                </div>

                {/* Requested For */}
                <div className="mb-3 row">
                  <label className="form-label col-md-2">Requested For</label>
                  <div className="col-md-10">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={assetData?.name || ""}
                      {...register("requested_for")}
                    />
                  </div>
                </div>

                {/* Issue Type + Category + Service Type + Options */}
                <div className="mb-3 row align-items-end">
                  {/* Issue Type */}
                  <div className="col-md-3">
                    <label className="form-label">Issue Type</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value="IT"
                      {...register("issue_type")}
                    />
                  </div>

                  {/* Category */}
                  <div className="col-md-3">
                    <label className="form-label">Category</label>
                    <select
                      className="form-select"
                      {...register("category", {
                        required: "Category is required",
                      })}
                    >
                      <option value="">-- Select --</option>
                      <option value="Incident">Incident</option>
                      <option value="Service Request">Service Request</option>
                      <option value="Onboarding">Onboarding</option>
                    </select>
                  </div>

                  {/* Service Type */}
                  {watchCategory === "Service Request" && (
                    <div className="col-md-3">
                      <label className="form-label">Service Type</label>
                      <select
                        className="form-select"
                        {...register("service_type", {
                          required: "Service type is required",
                        })}
                      >
                        <option value="">-- Select Service Type --</option>
                        <option value="Software Installation">Software</option>
                        <option value="Hardware Request">Hardware</option>
                      </select>
                    </div>
                  )}

                  {/* Software Option */}
                  {watchCategory === "Service Request" &&
                    watchServiceType === "Software Installation" && (
                      <div className="col-md-3">
                        <label className="form-label">Software</label>
                        <select
                          className="form-select"
                          {...register("software_option")}
                        >
                          <option value="">-- Select Software --</option>
                          <option value="Crunch Base">Crunch Base</option>
                          <option value="Nitro PDF">Nitro PDF</option>
                          <option value="Printer Driver color">
                            Printer Driver color
                          </option>
                          <option value="Outlook and Team Config on Phone">
                            Outlook and Team Config on Phone
                          </option>
                        </select>
                      </div>
                    )}

                  {/* Hardware Option */}
                  {watchCategory === "Service Request" &&
                    watchServiceType === "Hardware Request" && (
                      <div className="col-md-3">
                        <label className="form-label">Hardware</label>
                        <select
                          className="form-select"
                          {...register("hardware")}
                        >
                          <option value="">-- Select Hardware --</option>
                          <option value="System Storage Increase">
                            System Storage Increase
                          </option>
                          <option value="RAM">RAM</option>
                          <option value="StandBy Laptop">StandBy Laptop</option>
                          <option value="Battery">Battery</option>
                        </select>
                      </div>
                    )}
                </div>

                {/* Description */}
                <div className="mb-3 row">
                  <label className="form-label col-md-2">Description</label>
                  <div className="col-md-10">
                    <textarea
                      rows="5"
                      className={`form-control ${
                        errors.description ? "is-invalid" : ""
                      }`}
                      placeholder="Enter issue description"
                      {...register("description", {
                        required: "Description is required",
                      })}
                    ></textarea>
                    {errors.description && (
                      <div className="invalid-feedback">
                        {errors.description.message}
                      </div>
                    )}
                  </div>
                </div>

                {/* Attach Image */}
                <div className="mb-3 row">
                  <label className="form-label col-md-2">Attach Image</label>
                  <div className="col-md-10">
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      {...register("image")}
                    />
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div className="modal-footer">
                <button type="submit" className="btn btn-success">
                  Submit Issue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default RaiseIssue;
